import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
const SummarySubject = ({ request }) => {
  var _a;
  const { t } = useTranslation("enterprise_ai");
  const selected = (_a = request.payload.selection) == null ? void 0 : _a.messages.length;
  const name = /* @__PURE__ */ React.createElement("strong", null, request.payload.name);
  if (selected === void 0) {
    return name;
  }
  return /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "summary_subject.selected",
      count: selected,
      values: { name: request.payload.name },
      components: { strong: /* @__PURE__ */ React.createElement("strong", null) }
    }
  );
};
export default SummarySubject;
